import { LOAD_CHANNELS_ROOT } from '@/store/protocols'

export default [
    {
        name: 'lives',
        path: '/lives',
        component: () => import('./Root.vue'),
        meta: {
            asyncData: LOAD_CHANNELS_ROOT.join('/')
        }
    },
    {
        path: '/lives/index.html',
        component: () => import('./Root.vue'),
        meta: {
            asyncData: LOAD_CHANNELS_ROOT.join('/')
        }
    },
]